import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { format } from 'date-fns';
import PatientSearchBox from '../patient/PatientSearchBox';
import { CreateOverrideVisitProvider } from './overrideVisitTypes';
import { useZonedDateFormat } from '~/providers/ZonedDateFormatProvider';

interface ProviderPatientFirstStepProps {
  provider: CreateOverrideVisitProvider;
  calendarDateTime: Date;
  onPatientSelected: (patient: { id: number; title: string }) => void;
  onCancel: () => void;
}

const ProviderPatientFirstStep: React.FC<ProviderPatientFirstStepProps> = ({
  provider: _provider,
  calendarDateTime,
  onPatientSelected,
  onCancel,
}) => {
  const { timeLabelWithZone, timezone } = useZonedDateFormat();
  const formattedDateTime = (calendarDateTime && !isNaN(calendarDateTime.getTime()) 
    ? `${format(calendarDateTime, 'PP')} at ${timeLabelWithZone(calendarDateTime, true, timezone)}`
    : '');

  return (
    <Box sx={{ minWidth: 500 }}>
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" component="h2" sx={{ mb: 3 }}>
          Create Override Visit{formattedDateTime && ` for ${formattedDateTime}`}
        </Typography>

        <Box sx={{ mb: 3 }}>
          <Typography variant="caption" color="text.secondary" component="label">
            Patient
          </Typography>
          <PatientSearchBox
            emptyTextInputAfterSelect={false}
            onPatientClicked={(patient) => {
              onPatientSelected(patient);
            }}
          />
        </Box>
      </Box>

      <Box sx={{ 
        p: 2, 
        borderTop: '1px solid', 
        borderTopColor: 'divider',
        display: 'flex',
        justifyContent: 'flex-end'
      }}>
        <Button onClick={onCancel}>
          Cancel
        </Button>
      </Box>
    </Box>
  );
};

export default ProviderPatientFirstStep;
